import { render, staticRenderFns } from "./Samples.vue?vue&type=template&id=670e0837"
import script from "./Samples.vue?vue&type=script&lang=js"
export * from "./Samples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports